import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import ColorHelperIcon from "./color-helper.svg";

export default class PassageUnderlineUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("passageUnderline", (locale) => {
      const command = editor.commands.get("style");
      const passageUnderlineButtonView = new ButtonView();

      passageUnderlineButtonView.set({
        icon: ColorHelperIcon,
        isOn: false,
        isToggleable: true,
        label: t("Passage Underline"),
        tooltip: true,
      });

      passageUnderlineButtonView
        .bind("isEnabled")
        .to(command, "enabledStyles", (enabledStyles) => {
          return enabledStyles.includes("Passage Underline");
        });
      passageUnderlineButtonView.bind("isOn").to(command, "value", (value) => {
        return value.includes("Passage Underline");
      });

      passageUnderlineButtonView.on("execute", (e) => {
        editor.execute("style", { styleName: "Passage Underline" });
        editor.editing.view.focus();
      });
      return passageUnderlineButtonView;
    });
  }
}
